import React from 'react';

function Footer() {
  return (
    <footer className='p-3 mt-3' style={{backgroundColor: '#25292d'}}>
      <div className="container mx-auto px-4 text-center text-sm text-gray-400">
        <p style={{marginBottom: 0}}>
        Copyright © 2025 <span className="font-semibold text-white">Play It Forward</span> —  <span className="font-semibold text-white">Design and Developed</span> by{' '}
          <a 
            href="https://designography.ca/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-green-600 hover:underline"
          >
            Designo Graphy
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
